import Vue from 'vue'
import Vuex from 'vuex'
import { firebaseApp } from '../firebase';
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

export default new Vuex.Store({
    plugins: [createPersistedState({
        storage: window.sessionStorage
    })],
    state: {
        user: null,
        status: null,
        error: null

    },
    mutations: {

        setUser (state, payload) {
            state.user = payload
        },

        removeUser (state) {
            state.user = null
        },

        setStatus (state, payload) {
            state.status = payload
        },

        setError (state, payload) {
            state.error = payload
        }

    },
    actions: {
        signUpAction ({ commit }, payload) {
            commit('setStatus', 'loading')
            firebaseApp.auth().createUserWithEmailAndPassword(payload.email, payload.password)
                .then((response) => {
                    alert('success')
                    // response will have user
                    // user will have uid will be updated to the state
                    commit('setUser', response.user.uid)
                    commit('setStatus', 'success')
                    commit('setError', null)
                })
                .catch((error) => {
                    commit('setStatus', 'failure')
                    commit('setError', error.message)
                })
        },

        signInAction ({ commit }, payload) {
            firebaseApp.auth().signInWithEmailAndPassword(payload.email, payload.password)
                .then((response) => {
                    commit('setUser', response.user.uid)
                    commit('setStatus', 'success')
                    commit('setError', null)
                })
                .catch((error) => {
                    commit('setStatus', 'failure')
                    commit('setError', error.message)
                })
        },

        signOutAction ({ commit }) {
            firebaseApp.auth().signOut()
                .then(() => {
                    commit('setUser', null)
                    commit('setStatus', 'success')
                    commit('setError', null)
                })
                .catch((error) => {
                    commit('setStatus', 'failure')
                    commit('setError', error.message)
                })
        }
    },

    getters: {

        status (state) {
            return state.status
        },

        user (state) {
            sessionStorage.getItem('user')
            return state.user
        },

        error (state) {
            return state.error
        }
    }
})
